import { defineComponent as h, ref as b, computed as x, openBlock as r, createBlock as k, withCtx as w, createElementVNode as e, normalizeClass as d, unref as c, createElementBlock as s, toDisplayString as u, createCommentVNode as m, Fragment as _, renderList as q, normalizeStyle as f, renderSlot as C } from "vue";
import { useLandingAnimation as S } from "./index127.js";
import $ from "./index116.js";
const B = {
  key: 0,
  class: "text-xs font-semibold uppercase tracking-widest",
  style: { color: "var(--landing-primary)" }
}, V = {
  class: "mt-3 text-3xl font-bold md:text-4xl lg:text-5xl",
  style: { color: "var(--landing-dark)" }
}, L = { class: "flex flex-col gap-3" }, j = ["aria-expanded", "onClick"], z = { class: "flex items-center justify-between gap-4 px-6 py-5" }, A = {
  class: "text-base font-semibold",
  style: { color: "var(--landing-dark)" }
}, D = {
  class: "flex h-7 w-7 shrink-0 items-center justify-center rounded-full",
  style: { background: "var(--landing-bg-light)" },
  "aria-hidden": "true"
}, E = {
  key: 0,
  x1: "12",
  y1: "5",
  x2: "12",
  y2: "19"
}, F = {
  class: "border-t px-6 pb-5 pt-4",
  style: { "border-color": "var(--landing-faq-border)" }
}, N = {
  class: "text-sm leading-relaxed",
  style: { color: "var(--landing-faq-answer)" }
}, J = /* @__PURE__ */ h({
  __name: "LandingFAQ",
  props: {
    overline: {},
    title: {},
    items: {},
    bg: { default: "light" },
    primary: { default: "var(--base-colors-primary-primary800)" },
    id: {}
  },
  setup(t) {
    const n = b(/* @__PURE__ */ new Set());
    function v(l) {
      const a = new Set(n.value);
      a.has(l) ? a.delete(l) : a.add(l), n.value = a;
    }
    const { el: g, isVisible: i } = S(), p = x(() => ({
      "--landing-faq-card-bg": "var(--base-colors-neutral-neutral000)",
      "--landing-faq-border": "var(--base-colors-neutral-neutral200)",
      "--landing-faq-answer": "var(--base-colors-neutral-neutral500)"
    }));
    return (l, a) => (r(), k($, {
      bg: t.bg,
      id: t.id,
      primary: t.primary
    }, {
      default: w(() => [
        e("div", {
          ref_key: "el",
          ref: g,
          class: "mx-auto max-w-3xl"
        }, [
          e("div", {
            class: d(["mb-12 text-center transition-all duration-700", c(i) ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"])
          }, [
            t.overline ? (r(), s("span", B, u(t.overline), 1)) : m("", !0),
            e("h2", V, u(t.title), 1)
          ], 2),
          e("div", L, [
            (r(!0), s(_, null, q(t.items, (y, o) => (r(), s("div", {
              key: y.question,
              class: d(["transition-all duration-700", c(i) ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"]),
              style: f({ transitionDelay: c(i) ? `${o * 60}ms` : "0ms" })
            }, [
              e("button", {
                type: "button",
                class: "w-full overflow-hidden rounded-xl border text-left shadow-sm transition-shadow duration-200 hover:shadow-md",
                "aria-expanded": n.value.has(o),
                onClick: (I) => v(o),
                style: f([
                  p.value,
                  {
                    background: "var(--landing-faq-card-bg)",
                    borderColor: "var(--landing-faq-border)"
                  }
                ])
              }, [
                e("div", z, [
                  e("span", A, u(y.question), 1),
                  e("span", D, [
                    (r(), s("svg", {
                      class: "h-4 w-4",
                      style: f({
                        color: n.value.has(o) ? "var(--landing-primary)" : "var(--landing-dark)"
                      }),
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                      "stroke-width": "2.5"
                    }, [
                      n.value.has(o) ? m("", !0) : (r(), s("line", E)),
                      a[0] || (a[0] = e("line", {
                        x1: "5",
                        y1: "12",
                        x2: "19",
                        y2: "12"
                      }, null, -1))
                    ], 4))
                  ])
                ]),
                e("div", {
                  class: d([
                    "overflow-hidden transition-all duration-300 ease-in-out",
                    n.value.has(o) ? "max-h-96 translate-y-0 opacity-100" : "max-h-0 -translate-y-1 opacity-0"
                  ]),
                  style: { "transition-property": "max-height, opacity, transform" }
                }, [
                  e("div", F, [
                    e("p", N, u(y.answer), 1)
                  ])
                ], 2)
              ], 12, j)
            ], 6))), 128))
          ]),
          l.$slots.footer ? (r(), s("div", {
            key: 0,
            class: d(["mt-8 text-center transition-all delay-500 duration-700", c(i) ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"])
          }, [
            C(l.$slots, "footer")
          ], 2)) : m("", !0)
        ], 512)
      ]),
      _: 3
    }, 8, ["bg", "id", "primary"]));
  }
});
export {
  J as default
};
